export default __webpack_public_path__ + "static/media/facebook_bw.6e6f164e.svg";